import React from 'react'

import clsx from 'clsx'

import classes from './Radio.module.scss'

/** @type {import("./types").default} */
const Radio = ({ groupName, value, checked, disabled, ...props }) => (
  <span className={clsx('Radio', classes.ripple)}>
    <span className={clsx(classes.root, disabled && 'disabled', checked && 'checked')}>
      <input
        type="radio"
        name={groupName}
        value={value}
        className={classes.radio}
        checked={checked}
        disabled={disabled}
        {...props}
      />
    </span>
  </span>
)

export default Radio
